import { render, staticRenderFns } from "./LinkInventoryItemFilters.vue?vue&type=template&id=370095b0&scoped=true"
import script from "./LinkInventoryItemFilters.vue?vue&type=script&lang=ts"
export * from "./LinkInventoryItemFilters.vue?vue&type=script&lang=ts"
import style0 from "./LinkInventoryItemFilters.vue?vue&type=style&index=0&id=370095b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370095b0",
  null
  
)

export default component.exports